import { JDIPro } from '@jdiyield/abi'
import { ChainID } from '@jdiyield/constants'
import dayjs from 'dayjs'
import Web3 from 'web3'

import getNodeUrl from '../rpcRandom'
import { safeGasEstimates } from '../utils'

export const registerProFeature = async (web3: Web3, choice: number, walletAddress: string): Promise<boolean> => {
  try {
    const contract = new web3.eth.Contract(JDIPro as any, process.env.NEXT_PUBLIC_PRO_CONTRACT)
    const contractWithMethod = contract.methods.subscribe(choice)
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({
      from: walletAddress,
      gas: gasLimit
    })
    return true
  } catch (error) {
    console.log('registerProFeature', choice, error)
    return false
  }
}

export const unSubscribeProFeature = async (web3: Web3, walletAddress: string): Promise<boolean> => {
  try {
    const contract = new web3.eth.Contract(JDIPro as any, process.env.NEXT_PUBLIC_PRO_CONTRACT)
    const contractWithMethod = contract.methods.unSubscribe()
    const gasLimit = await safeGasEstimates({ contractWithMethod, walletAddress })

    await contractWithMethod.send({
      from: walletAddress,
      gas: gasLimit
    })
    return true
  } catch (error) {
    console.log('unSubscribeProFeature', error)
    return false
  }
}

export const checkProActivate = async (
  walletAddress: string
): Promise<{ isActivated: boolean; packageId: number; expiredTime: number }> => {
  try {
    const web3 = new Web3(getNodeUrl((+process.env.NEXT_PUBLIC_MAIN_CHAIN_ID || 56) as ChainID))
    const contract = new web3.eth.Contract(JDIPro as any, process.env.NEXT_PUBLIC_PRO_CONTRACT)
    const { endTime, packageId } = await contract.methods.userSubscribe(walletAddress).call()
    const isActivated = endTime >= dayjs().unix()
    return { isActivated, packageId: isActivated ? +packageId : -1, expiredTime: +endTime }
  } catch (error) {
    console.log('checkProActivate', error)
    return { isActivated: false, packageId: -1, expiredTime: 0 }
  }
}
